import { Modal as AntModal } from 'antd'
import { AxiosError } from 'axios'

const renderValidationErrors = (validationErrors: any) => {
  const keys = Object.keys(validationErrors)
  return (
    <>
      <dt>Invalid Values</dt>
      <dd>
        <dl className="validation-failure">
          {keys.map(k => (
            <>
              <dt key={`${k}-dt`}>{k}</dt>
              <dd key={`${k}-dd`}>
                <ul key={`${k}-ul`}>
                  {validationErrors[k].map(v => (
                    <li key={v}>{v}</li>
                  ))}
                </ul>
              </dd>
            </>
          ))}
        </dl>
      </dd>
    </>
  )
}

export const handleApiFailure = (error: AxiosError<any, any>) => {
  console.error('API Failure', error)
  AntModal.error({
    title: 'Something went wrong with your request',
    width: 700,
    content: (
      <dl className="api-failure">
        <dt>Message</dt>
        <dd>{`${error}`}</dd>
        {error.response?.status && (
          <>
            <dt>Status</dt>
            <dd>{error.response?.status}</dd>
          </>
        )}
        {error?.response?.data?.title && (
          <>
            <dt>Reason</dt>
            <dd>{error?.response?.data?.title}</dd>
          </>
        )}
        {(typeof error?.response?.data === 'string' || error?.response?.data instanceof String) && (
          <>
            <dt>Details</dt>
            <dd>{error?.response?.data}</dd>
          </>)}
        {typeof error?.response?.data !== 'string' && !(error?.response?.data instanceof String) &&
          error?.response?.status === 400 && error?.response?.data?.errors &&
          renderValidationErrors(error.response.data.errors)}
      </dl>
    )
  })
}
